import { Matches, MaxLength, IsOptional, IsNotEmpty, IsEnum } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { FgStatusEnum } from "@gtpl/shared-models/common-models";

export class ComplaintsDTO{

    @ApiProperty()
    @IsOptional()
    complaintId?: number;

    @ApiProperty()
    @IsNotEmpty({message: "Complaint should not be empty"})
    complaint: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Department should not be empty'})
    departmentId: number;
    departmentName?: string;

    @ApiProperty()
    complaintRaisedDate: Date;

    @ApiProperty({
        enum: FgStatusEnum
    })
    @IsNotEmpty({message: 'Status should not be empty'})
    @IsEnum(FgStatusEnum)
    status: FgStatusEnum;

    @ApiProperty()
    isActive: boolean;
    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created user allows maximun 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Created user should contain only characters'})
    createdUser: string;
    
    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Updated user should contain only characters'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

}